import { ButtonIconPermissioned } from "components/ButtonIconPermissioned/ButtonIconPermissioned";
import { ModalDeleteDrsFileProps } from "components/ModalDeleteDrsFile/ModalDeleteDrsFile";
import { getDrsFileModifyPermissionByDrsFileAndAction } from "types/DrsFileModifyPermissions";

export interface ButtonDeleteDrsFileProps {
  drsFile: ModalDeleteDrsFileProps["drsFiles"][number];
  onClick: (file: ButtonDeleteDrsFileProps["drsFile"]) => void;
}

export const ButtonDeleteDrsFile = ({
  drsFile,
  onClick,
}: ButtonDeleteDrsFileProps) => {
  return (
    <ButtonIconPermissioned
      aria-label="Delete file"
      defaultTooltip={"Delete file"}
      color="danger"
      iconType="trash"
      disabled={
        !getDrsFileModifyPermissionByDrsFileAndAction(drsFile, "DELETE")
          .isPermitted ||
        !getDrsFileModifyPermissionByDrsFileAndAction(drsFile, "DATA_DELETE")
          .isPermitted
      }
      onClick={() => onClick(drsFile)}
      requiredPermission="edit"
    />
  );
};
